/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { CommsChannelsResponse } from '../models/commsChannelsResponse';

import type { CommsReachabilityApiV1CommsReachabilityGetParams } from '../models/commsReachabilityApiV1CommsReachabilityGetParams';

import type { CommsReachabilityResponse } from '../models/commsReachabilityResponse';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Every registered channel with this tenant's availability and live connections.
 * @summary List Comms Channels
 */
export const listCommsChannelsApiV1CommsChannelsGet = (
  signal?: AbortSignal
) => {
  return customInstance<CommsChannelsResponse>({
    url: `/api/v1/comms/channels`,
    method: 'GET',
    signal
  });
};

export const getListCommsChannelsApiV1CommsChannelsGetQueryKey = () => {
  return [`/api/v1/comms/channels`] as const;
};

export const getListCommsChannelsApiV1CommsChannelsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCommsChannelsApiV1CommsChannelsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>
  > = ({ signal }) => listCommsChannelsApiV1CommsChannelsGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListCommsChannelsApiV1CommsChannelsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>
>;
export type ListCommsChannelsApiV1CommsChannelsGetQueryError = unknown;

export function useListCommsChannelsApiV1CommsChannelsGet<
  TData = Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
          TError,
          Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCommsChannelsApiV1CommsChannelsGet<
  TData = Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
          TError,
          Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCommsChannelsApiV1CommsChannelsGet<
  TData = Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Comms Channels
 */

export function useListCommsChannelsApiV1CommsChannelsGet<
  TData = Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCommsChannelsApiV1CommsChannelsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCommsChannelsApiV1CommsChannelsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Per-party reachability on every registered channel, batched.

Repeat ``contact_id`` / ``organization_id`` / ``participant_id`` for a batch; rows
come back in that order (contacts, then organizations, then participants).
 * @summary Comms Reachability
 */
export const commsReachabilityApiV1CommsReachabilityGet = (
  params?: CommsReachabilityApiV1CommsReachabilityGetParams,
  signal?: AbortSignal
) => {
  return customInstance<CommsReachabilityResponse>({
    url: `/api/v1/comms/reachability`,
    method: 'GET',
    params,
    signal
  });
};

export const getCommsReachabilityApiV1CommsReachabilityGetQueryKey = (
  params?: CommsReachabilityApiV1CommsReachabilityGetParams
) => {
  return [`/api/v1/comms/reachability`, ...(params ? [params] : [])] as const;
};

export const getCommsReachabilityApiV1CommsReachabilityGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>
  >,
  TError = HTTPValidationError
>(
  params?: CommsReachabilityApiV1CommsReachabilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCommsReachabilityApiV1CommsReachabilityGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>>
  > = ({ signal }) =>
    commsReachabilityApiV1CommsReachabilityGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CommsReachabilityApiV1CommsReachabilityGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>>
>;
export type CommsReachabilityApiV1CommsReachabilityGetQueryError =
  HTTPValidationError;

export function useCommsReachabilityApiV1CommsReachabilityGet<
  TData = Awaited<
    ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | CommsReachabilityApiV1CommsReachabilityGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>
          >,
          TError,
          Awaited<ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCommsReachabilityApiV1CommsReachabilityGet<
  TData = Awaited<
    ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>
  >,
  TError = HTTPValidationError
>(
  params?: CommsReachabilityApiV1CommsReachabilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>
          >,
          TError,
          Awaited<ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCommsReachabilityApiV1CommsReachabilityGet<
  TData = Awaited<
    ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>
  >,
  TError = HTTPValidationError
>(
  params?: CommsReachabilityApiV1CommsReachabilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Comms Reachability
 */

export function useCommsReachabilityApiV1CommsReachabilityGet<
  TData = Awaited<
    ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>
  >,
  TError = HTTPValidationError
>(
  params?: CommsReachabilityApiV1CommsReachabilityGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof commsReachabilityApiV1CommsReachabilityGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getCommsReachabilityApiV1CommsReachabilityGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
